export default __webpack_public_path__ + "static/media/timezone-icon.2b17abb0.svg";